<template>
  <div class="d-flex justify-space-between">
    <ThemedSelector
      :items="voyageComputations"
      :item-text="displayComputation"
      no-data-text="No computations found"
      return-object
      cache-items
      outlined
      dense
      hide-details
      append-icon="none"
      v-model="selectedComputationModel"
      label="Selected computation"
      persistent-placeholder
      :rules="[]"
      :menu-props="{ bottom: true, offsetY: true }"
    >
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-bind="attrs" v-on="on" class="computation-item">
          <v-list-item-content>
            {{ displayComputation(item) }}
          </v-list-item-content>
        </v-list-item>
      </template>
    </ThemedSelector>
    <OptionsMenu />
  </div>
</template>
    
<script>
import { mapState, mapActions } from "vuex";
import ThemedSelector from "@/core/ThemedSelector.vue";
// import RecomputeVoyage from "./recompute_voyage/Dialog.vue";
import OptionsMenu from "./options/OptionsMenu.vue";
export default {
  name: "PreviousComputationsComponent",
  components: {
    OptionsMenu,
    ThemedSelector,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/voyageDetailsModule", [
      "voyageComputations",
      "selectedComputation",
    ]),
    selectedComputationModel: {
      get() {
        return this.selectedComputation;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/voyageDetailsModule/SET_SELECTED_COMPUTATION",
          value,
          { root: true }
        );
        this.onComputationSelected();
      },
    },
  },
  methods: {
    ...mapActions("weatherRouting/voyageDetailsModule", [
      "getVoyageComputations",
      "checkSelectedComputationState",
    ]),
    async onComputationSelected() {
      const voyageId = this.$route.params.voyageId;
      await this.checkSelectedComputationState(voyageId);
    },
    displayComputation(computationData) {
      const date = computationData.computationDate;
      const time = computationData.computationTime;
      const computation = computationData.computation;

      return `${date} ${time} (${computation})`;
    },
  },
};
</script>

<style scoped>
.computation-item {
  min-height: 36px;
  padding: 0 16px;
}

.computation-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.computation-item.v-list-item--active {
  background-color: rgba(var(--v-theme-primary), 0.18);
}

.computation-item .v-list-item__title {
  font-size: 15px;
  line-height: 1.2;
  font-weight: 500;
}
</style>
